import type { FormListType } from '@/models/app';
import { deliveryTabRoles } from '@/constants/deliveryOrder';
import { qaCalibrationRoles } from '@/constants/qaCalibration';

export const formList: FormListType[] = [
  {
    name: 'Live Calls',
    type: 'warning',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/live-calls',
    id: 'live-calls',
    parentName: 'Live Calls',
  },
  {
    name: 'Supervisor Pending Calls',
    type: 'warning',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/live-calls',
    id: 'supervisor-pending-calls-table',
    parentName: 'Live Calls',
  },
  {
    name: 'Missed Calls',
    type: 'warning',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/live-calls',
    id: 'missed-calls-table',
    parentName: 'Live Calls',
  },
  {
    name: 'Online Operators',
    type: 'warning',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/live-calls',
    id: 'online-operators',
    parentName: 'Live Calls',
  },
  {
    name: 'SMS Board',
    type: 'success',
    icon: 'fa fa-comments',
    path: '/operator/sms-board',
    id: 'sms-board',
    parentName: 'SMS',
    roles: [
      'admin',
      'director',
      'supervisor',
      'lossPrevention',
      'lossPreventionGourmet',
      'lossPreventionGrocery',
      'research-operator',
      'homeServices-operator',
      'gogo-welcome-operator',
      'facebookLeads-registrations-operator',
    ],
  },
  {
    name: 'Live Rides',
    type: 'info',
    icon: 'fa fa-taxi',
    path: '/operator/live-ride',
    parentName: 'Live Rides',
  },
  {
    name: 'Ride Ordering',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'order-rides',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Cancel Ride',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'cancel-ride',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Cancel Auto Retry Ride',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'cancel-auto-retry-ride',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Update Uber & Lyft Ride Destination',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'uber-ride-destination',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Rescan Ride for Changes',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'rescan-ride',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Text the Driver',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'text-the-driver',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Text the Customer',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'text-the-customer',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Send Driver Arriving Call',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'driver-arriving-call',
    parentName: 'Ride Ordering',
    roles: [
      'admin',
      'director',
      'supervisor',
      'teamLead',
      'operator',
      'gourmet-operator',
      'grocery-operator',
      'rideTeamLead',
      'lossPrevention',
    ],
  },
  {
    name: 'Send Driver Details via Call/SMS',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'send-driver-details',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Send Pharmacy Driver Has Arrived Call',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'pharmacy-driver-arriving-call',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    parentName: 'Ride Ordering',
  },
  {
    name: 'Emergency Ride Request',
    type: 'danger',
    icon: 'fa fa-car',
    path: '/operator/ride-ordering',
    id: 'emergency-ride-request',
    parentName: 'Ride Ordering',
  },
  {
    name: 'Ride Monitoring',
    type: 'info',
    icon: 'fa fa-desktop',
    path: '/operator/ride-monitoring',
    id: 'ride-monitoring',
    parentName: 'Ride Monitoring',
  },
  {
    name: 'Ride History',
    type: 'success',
    icon: 'fa fa-search',
    path: '/operator/ride-history',
    id: 'ride-search',
    parentName: 'Ride History',
  },
  {
    name: 'Ride Activities',
    type: 'success',
    icon: 'fa fa-search',
    path: '/operator/ride-history',
    id: 'ride-activities',
    parentName: 'Ride History',
  },
  {
    name: 'Get Original Ride Estimate',
    type: 'success',
    icon: 'fa fa-search',
    path: '/operator/ride-history',
    id: 'ride-estimation',
    parentName: 'Ride History',
  },
  {
    name: 'User Search',
    type: 'danger',
    icon: 'fa fa-user',
    path: '/operator/user-search',
    parentName: 'User Search',
  },
  {
    name: 'Email Search',
    type: 'warning',
    icon: 'fa fa-envelope',
    path: '/operator/email-search',
    parentName: 'Email Search',
  },
  {
    name: 'SMS Search',
    type: 'info',
    icon: 'fa fa-fax',
    path: '/operator/sms-search',
    parentName: 'SMS Search',
  },
  {
    name: 'Mailings Search',
    type: 'info',
    icon: 'fa fa-envelope',
    path: '/operator/mailings-search',
    parentName: 'Mailings Search',
  },
  {
    name: 'Referral Search',
    type: 'warning',
    icon: 'fa fa-envelope',
    path: '/operator/referral-search',
    parentName: 'Referral Search',
  },
  {
    name: 'Scheduled Rides',
    type: 'info',
    icon: 'fa fa-calendar',
    path: '/operator/scheduled-rides',
    parentName: 'Scheduled Rides',
  },
  {
    name: 'Create & Update Ride Scheduler',
    type: 'info',
    icon: 'fa fa-calendar',
    path: '/operator/ride-scheduler',
    id: 'ride-scheduler',
    parentName: 'Scheduled Rides',
  },
  {
    name: 'Call Logs',
    type: 'warning',
    icon: 'fa fa-history',
    path: '/operator/call-logs',
    id: 'call-logs-table',
    parentName: 'Call Logs',
  },
  {
    name: 'Call Summary',
    type: 'warning',
    icon: 'fa fa-history',
    path: '/operator/call-logs',
    id: 'call-summary',
    roles: [
      'admin',
      'director',
      'supervisor',
      'teamLead',
      'lossPrevention',
      'rideTeamLead',
      'grocery-manager',
      'gourmet-supervisor',
      'qualityAssurance',
    ],
    parentName: 'Call Logs',
    searchKey: 'summary',
  },
  {
    name: 'QA Calibration Form',
    type: 'warning',
    icon: 'fa fa-history',
    path: '/operator/call-logs',
    id: 'qa-calibration',
    parentName: 'Call Logs',
  },
  {
    name: 'QA Calibrations',
    type: 'warning',
    icon: 'fa fa-balance-scale',
    path: '/operator/qa-calibrations',
    id: 'qa-calibrations',
    parentName: 'QA Calibrations',
    searchKey: 'calibration dispute',
    roles: qaCalibrationRoles,
  },
  {
    name: 'Call Record Player',
    type: 'warning',
    icon: 'fa fa-history',
    path: '/operator/call-logs',
    id: 'call-record-player',
    parentName: 'Call Logs',
  },
  {
    name: 'Operator Report',
    type: 'warning',
    icon: 'fa fa-history',
    path: '/operator/call-logs',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operator-report',
    parentName: 'Call Logs',
  },
  {
    name: 'Change Password',
    icon: 'fa fa-user-circle-o',
    type: 'info',
    id: 'change-password',
    path: '/operator/account',
    parentName: 'Accounts',
  },
  {
    name: 'Current User Operator Activities',
    icon: 'fa fa-user-circle-o',
    type: 'info',
    id: 'operator-activities',
    path: '/operator/account',
    roles: ['operator', 'grocery-operator', 'gourmet-operator'],
    parentName: 'Accounts',
  },
  {
    name: 'Current User Operator Activities Summary',
    icon: 'fa fa-user-circle-o',
    type: 'info',
    id: 'operator-activities-summary',
    path: '/operator/account',
    parentName: 'Accounts',
  },
  {
    name: 'New Request Access',
    type: 'info',
    icon: 'fa fa-user-circle-o',
    path: '/operator/account',
    id: 'new-request-access',
    parentName: 'Accounts',
    searchKey: 'request, access',
  },
  {
    name: 'Customer Reset Password',
    icon: 'fa fa-user-circle-o',
    type: 'info',
    path: '/operator/customer-reset-password',
    id: 'customer-reset-password',
    parentName: 'Accounts',
  },
  {
    name: 'Save Custom Location',
    icon: 'fa fa-address-book',
    type: 'info',
    path: '/operator/custom-locations',
    id: 'custom-locations',
    parentName: 'Custom Locations',
  },
  {
    name: 'User Communication Preferences',
    icon: 'fa fa-cogs',
    type: 'info',
    path: '/operator/communication-preferences',
    parentName: 'User Communication Preferences',
  },
  {
    name: 'Email Checker',
    icon: 'fa fa-cogs',
    type: 'info',
    path: '/operator/communication-preferences',
    id: 'email-checker',
    parentName: 'User Communication Preferences',
  },
  {
    name: 'Exclude A/B Test',
    icon: 'fa fa-cogs',
    type: 'info',
    path: '/operator/communication-preferences',
    id: 'exclude-ab-test',
    parentName: 'User Communication Preferences',
  },
  {
    name: 'Operators',
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/operators',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operators-list',
    parentName: 'Operators',
  },
  {
    name: 'Add & Update Operator',
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/add-operator',
    id: 'add-operator',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    parentName: 'Operators',
  },
  {
    name: 'Operator Sign On / Off',
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/operators',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operator-sign-on-off',
    parentName: 'Operators',
  },
  {
    name: 'Operator Activities',
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/operators',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operator-activities-management',
    parentName: 'Operators',
  },
  {
    name: 'Operator Activities Summary',
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/operators',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operator-activities-summary-management',
    parentName: 'Operators',
  },
  {
    name: "Team Lead's Operator Activities Summary",
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/operators',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'team-lead-operator-activities-summary',
    parentName: 'Operators',
  },
  {
    name: 'Weekly AI Scores',
    type: 'success',
    icon: 'fa fa-star-half-o',
    path: '/operator/operators',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'weekly-ai-scores',
    parentName: 'Operators',
  },
  {
    name: 'Change User Roles',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/operators',
    roles: ['admin', 'director', 'teamLead', 'rideTeamLead', 'supervisor', 'grocery-manager', 'gourmet-supervisor'],
    id: 'change-user-roles',
    parentName: 'Operators',
  },
  {
    name: 'Operator Forms',
    type: 'success',
    icon: 'fa fa-file-text-o',
    path: '/operator/operators',
    roles: ['admin', 'director', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operator-forms',
    parentName: 'Operator Forms',
  },
  {
    name: 'Get Estimation',
    type: 'success',
    icon: 'fa fa-dollar',
    path: '/operator/service-check',
    id: 'get-estimation',
    parentName: 'Service Check',
  },
  {
    name: 'Search Estimation Result',
    type: 'success',
    icon: 'fa fa-dollar',
    path: '/operator/service-check',
    id: 'search-estimation-results',
    parentName: 'Service Check',
  },
  {
    name: 'Manually Add Credit Card',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'add-credit-card',
    parentName: 'Payments',
  },
  {
    name: 'Pay for Any Unpaid Rides',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'pay-unpaid-rides',
    parentName: 'Payments',
  },
  {
    name: 'Pay for Any Unpaid Groceries',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'pay-unpaid-groceries',
    parentName: 'Payments',
  },
  {
    name: 'Pay for Any Unpaid Services',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'pay-unpaid-services',
    parentName: 'Payments',
  },
  {
    name: 'Individual Charge',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'individual-charge',
    roles: [
      'admin',
      'director',
      'supervisor',
      'teamLead',
      'rideTeamLead',
      'gourmet-supervisor',
      'gourmet-operator',
      'grocery-operator',
      'grocery-manager',
    ],
    parentName: 'Payments',
  },
  {
    name: 'Credit Cards',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'credit-card-list',
    parentName: 'Payments',
  },
  {
    name: 'All Transactions',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'transaction-list',
    parentName: 'Payments',
  },
  {
    name: 'Get Transaction Distributions',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'transaction-distributions',
    parentName: 'Payments',
  },
  {
    name: 'Get Stripe Charge',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'stripe-charge',
    parentName: 'Payments',
  },
  {
    name: 'Payment Intents',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'paymentIntents',
    parentName: 'Payments',
  },
  {
    name: 'Charge for Ride Immediately',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'charge-ride-immediately',
    parentName: 'Payments',
  },
  {
    name: 'Credits Balance',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'credits-balance',
    parentName: 'Payments',
  },
  {
    name: 'Disputes',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'check-disputes',
    parentName: 'Payments',
  },
  {
    name: 'Pay Off Dispute',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'pay-off-dispute',
    parentName: 'Payments',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
  },
  {
    name: 'Refund Pay Off Dispute',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'refund-paid-off-dispute',
    parentName: 'Payments',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
  },
  {
    name: 'Resolve Dispute without Charge',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'resolve-dispute-without-charge',
    parentName: 'Payments',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
  },
  {
    name: 'Expiring Credits',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'expiring-credits',
    parentName: 'Payments',
  },
  {
    name: 'All Expiring Credit Transactions',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/payments',
    id: 'expiring-credit-transaction-list',
    parentName: 'Payments',
  },
  {
    name: 'Add GoGo Credits',
    type: 'info',
    icon: 'fa fa-credit-card',
    path: '/operator/ride-credits',
    id: 'add-ride-credit',
    parentName: 'GoGo Credits',
  },
  {
    name: 'Bulk Check Sending',
    type: 'info',
    icon: 'fa fa-money',
    path: '/operator/checks',
    id: 'bulk-check-send',
    parentName: 'Checks',
    roles: ['research-admin'],
    searchKey: 'checks, bulk check, lob, send checks',
  },
  {
    name: 'Check Batch Status',
    type: 'info',
    icon: 'fa fa-money',
    path: '/operator/checks',
    id: 'check-batch-status',
    parentName: 'Checks',
    roles: ['research-admin'],
    searchKey: 'checks, batch status, lob, check status',
  },
  {
    name: 'Redeem an Uber Gift Card',
    type: 'info',
    icon: 'fa fa-credit-card',
    path: '/operator/ride-credits',
    id: 'redeem-uber-gift',
    parentName: 'GoGo Credits',
  },
  {
    name: 'Auto Reload GoGo Credits',
    type: 'info',
    icon: 'fa fa-credit-card',
    path: '/operator/ride-credits',
    id: 'auto-reload-ride-credits',
    parentName: 'GoGo Credits',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
  },
  {
    name: 'Prepaid Card Amount Approval',
    type: 'info',
    icon: 'fa fa-credit-card',
    path: '/operator/ride-credits',
    id: 'prepaid-card-amount-approval',
    parentName: 'GoGo Credits',
  },
  {
    name: 'Pull Up Receipt',
    type: 'warning',
    icon: 'fa fa-copy',
    path: '/operator/receipts',
    id: 'pull-up-receipt',
    parentName: 'Receipts',
  },
  {
    name: 'Send Receipt',
    type: 'warning',
    icon: 'fa fa-copy',
    path: '/operator/receipts',
    id: 'send-receipt',
    parentName: 'Receipts',
  },
  {
    name: 'Send Ride History',
    type: 'warning',
    icon: 'fa fa-copy',
    path: '/operator/receipts',
    id: 'send-ride-history',
    parentName: 'Receipts',
  },
  {
    name: 'Mail Another Welcome Packet',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'send-physical-brochure',
    parentName: 'Marketing',
  },
  {
    name: 'Add Promo Code',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'add-promo-code',
    parentName: 'Marketing',
  },
  {
    name: 'Send Marketing Emails',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'send-marketing-email',
    parentName: 'Marketing',
  },
  {
    name: 'Submit Marketing Inquiry',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'marketing-inquiry',
    parentName: 'Marketing',
  },
  {
    name: 'Send Post Cards',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'send-post-card',
    parentName: 'Marketing',
  },
  {
    name: 'GoGo Mailings',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'gogo-mailings',
    parentName: 'Marketing',
  },
  {
    name: 'Activation Promo Codes',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'activation-promo-codes',
    parentName: 'Marketing',
  },
  {
    name: 'Search Promo Codes',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'search-promo-codes-sent-to-users',
    parentName: 'Marketing',
  },
  {
    name: 'Marketing Analytics Phone Numbers',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'marketing-analytics-phone-numbers',
    parentName: 'Marketing',
    roles: ['admin', 'director'],
  },
  {
    name: 'SMS Templates',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'sms-templates-table',
    parentName: 'Marketing',
    roles: ['admin', 'director'],
  },
  {
    name: 'Custom Reports',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'custom-reports',
    parentName: 'Marketing',
    roles: ['admin', 'director'],
  },
  {
    name: 'Impact Partners',
    type: 'success',
    icon: 'fa fa-line-chart',
    path: '/operator/marketing',
    id: 'impact-partners-table',
    parentName: 'Marketing',
    roles: ['admin', 'director'],
  },
  {
    name: 'Send Bulk SMS',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/marketing',
    roles: ['gogo-welcome-operator'],
    id: 'marketing-send-bulk-sms',
    parentName: 'Marketing',
  },
  // {
  //   name: 'Request for Material',
  //   type: 'success',
  //   icon: 'fa fa-line-chart',
  //   path: '/operator/marketing',
  //   id: 'request-material',
  //   parentName: 'Marketing',
  // },
  {
    name: 'Ping Test',
    type: 'success',
    icon: 'fa fa-tachometer',
    path: '/operator/ping-test',
    id: 'ping-tests',
    parentName: 'PingTest',
  },
  {
    name: 'Add Family Member',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'add-family-member',
    parentName: 'Family Member',
  },
  {
    name: 'Send Test SMS',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'send-test-sms',
    parentName: 'Family Member',
  },
  {
    name: 'Assign Family Member to Caller',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'assign-family-to-caller',
    parentName: 'Family Member',
  },
  {
    name: 'Loved One Search',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'search-lovedone',
    parentName: 'Family Member',
  },
  {
    name: 'Caller Active Hours',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'caller-active-hours',
    parentName: 'Family Member',
  },
  {
    name: 'Loved One Call & Sms & Email',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'loved-one-call-sms-email-options',
    parentName: 'Family Member',
  },
  {
    name: 'Remove LovedOne Email',
    type: 'info',
    icon: 'fa fa-heart-o',
    path: '/operator/family-member',
    id: 'remove-lovedone-email',
    parentName: 'Family Member',
  },
  {
    name: 'Lookup Carrier Account Info',
    searchKey: 'voip',
    type: 'warning',
    icon: 'fa fa-list-alt',
    path: '/operator/blacklist',
    id: 'lookup-carrier',
    parentName: 'Blacklist',
  },
  {
    name: 'Request Identity Information and POA',
    type: 'warning',
    icon: 'fa fa-list-alt',
    path: '/operator/blacklist',
    id: 'identity-information',
    parentName: 'Blacklist',
  },
  {
    name: 'Request To Blacklist Caller',
    type: 'warning',
    icon: 'fa fa-list-alt',
    path: '/operator/blacklist',
    id: 'report-blacklist-user',
    parentName: 'Blacklist',
  },
  {
    name: 'Search / Update / Activate Blacklist',
    type: 'warning',
    icon: 'fa fa-list-alt',
    path: '/operator/blacklist',
    id: 'search-black-list',
    parentName: 'Blacklist',
  },
  {
    name: 'Create Need Love Form',
    type: 'danger',
    icon: 'fa fa-heart',
    path: '/operator/need-love',
    id: 'create-need-love-form',
    parentName: 'Need Love',
  },
  {
    name: 'Request For A Supervisor Callback',
    type: 'danger',
    icon: 'fa fa-heart',
    path: '/operator/need-love',
    id: 'request-supervisor-callback',
    parentName: 'Need Love',
  },
  {
    name: 'Uber Lost Item',
    type: 'danger',
    icon: 'fa fa-heart',
    path: '/operator/need-love',
    id: 'uber-lost-item',
    parentName: 'Need Love',
    roles: ['admin', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead'],
  },
  {
    name: 'Search Form Stack',
    type: 'danger',
    icon: 'fa fa-heart',
    path: '/operator/need-love',
    id: 'search-form-stack',
    parentName: 'Need Love',
  },
  {
    name: 'Mark Ride Status',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead'],
    id: 'mark-ride',
    searchKey: 'stuck, false trip',
    parentName: 'Management',
  },
  {
    name: 'Plans',
    type: 'info',
    icon: 'fa fa-list',
    path: '/operator/plans',
    id: 'operator-plan-management',
    parentName: 'Management',
    roles: ['admin', 'director'],
  },
  {
    name: 'Payment Tiers',
    type: 'info',
    icon: 'fa fa-list',
    path: '/operator/payment-tiers',
    id: 'operator-payment-tier-management',
    parentName: 'Management',
    roles: ['admin', 'director'],
  },
  {
    name: 'Unmark Ride Status',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead'],
    id: 'unmark-ride',
    parentName: 'Management',
  },
  {
    name: 'Send Bulk Email',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'send-bulk-email',
    parentName: 'Management',
  },
  {
    name: 'Send Robo Calls',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'send-robo-calls',
    parentName: 'Management',
  },
  {
    name: 'Send Bulk SMS',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'research-operator', 'rideTeamLead'],
    id: 'send-bulk-sms',
    parentName: 'Management',
  },
  {
    name: 'Send Bulk AI SMS',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'send-bulk-ai-sms',
    parentName: 'Management',
  },
  {
    name: 'Account Deactivation Request Reminder',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'account-deactivation-request-reminder',
    parentName: 'Management',
  },
  {
    name: 'Free Trial Reminder',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'free-trial-reminder',
    parentName: 'Management',
  },
  {
    name: 'Do Not Charge Ride',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead'],
    id: 'do-not-charge-ride',
    parentName: 'Management',
  },
  {
    name: 'Unmark Do Not Charge Ride',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead'],
    id: 'unmark-do-not-charge-ride',
    parentName: 'Management',
  },
  {
    name: 'Clear User of Fraud Suspicion',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'clear-user-fraud',
    parentName: 'Management',
  },
  {
    name: 'Add Referral Code',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'add-referral-code',
    parentName: 'Management',
  },
  {
    name: 'Transfer Ride to Another Account',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'transfer-ride',
    parentName: 'Management',
  },
  {
    name: 'Transfer GoGo Credits',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'transfer-ride-credits',
    parentName: 'Management',
  },
  {
    name: 'Remove any Credit Cards, Debit Cards, Bank Accounts on File',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'remove-all-payments',
    parentName: 'Management',
  },
  {
    name: 'Blacklist User',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'submit-blacklist-user',
    parentName: 'Management',
  },
  {
    name: 'Send Need Love Response Email / Automated Call',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'send-email-automated-call',
    parentName: 'Management',
  },
  {
    name: 'Send Account Reactivation Email',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'send-account-reactivation-email',
    parentName: 'Management',
  },
  {
    name: 'Update Customer Password',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'update-customer-password',
    parentName: 'Management',
  },
  {
    name: 'Driver Search',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'driver-search',
    parentName: 'Management',
  },
  {
    name: 'Ban Caller Car Type',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'ban-caller-car-type',
    parentName: 'Management',
  },
  {
    name: 'Upload User Document',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'upload-user-document',
    parentName: 'Management',
  },
  {
    name: 'Update Partner Subsidy Locations',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'partnership-operator'],
    id: 'update-subsidy-locations',
    parentName: 'Management',
  },
  {
    name: 'Blacklist Address',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'blacklist-address',
    parentName: 'Management',
  },
  {
    name: 'Closed Accounts',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'closed-accounts',
    parentName: 'Management',
  },
  {
    name: 'Car Type List',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'car-types-list',
    parentName: 'Management',
  },
  {
    name: 'Announcements',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor'],
    id: 'announcements',
    parentName: 'Management',
  },
  {
    name: 'Search Op Report Form Stack ',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'operator-report-form-stack-search',
    parentName: 'Management',
  },
  {
    name: 'Remove Customer Permanently',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin'],
    id: 'remove-customer-permanently',
    parentName: 'Management',
  },
  {
    name: 'Grant Requests',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin'],
    id: 'greant-requests',
    parentName: 'Management',
    searchKey: 'request, access, grant',
  },
  {
    name: 'Send Promotion Email/SMS',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor'],
    id: 'send-promotion-email-sms',
    parentName: 'Management',
  },
  {
    name: 'Outbound Call Queue',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor'],
    id: 'outbound-call-queue',
    parentName: 'Management',
  },
  {
    name: 'Sling Team Lead Sync',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['teamLead'],
    id: 'sling-team-lead-sync',
    parentName: 'Management',
  },
  {
    name: 'Registration Urls',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'director'],
    id: 'registration-urls-table',
    parentName: 'Management',
  },
  {
    name: 'Plan Trials',
    type: 'danger',
    icon: 'fa fa-flask',
    path: '/operator/management',
    roles: ['admin', 'director'],
    id: 'plan-trials-table',
    parentName: 'Management',
    searchKey: 'plan trial, trials, plan',
  },
  {
    name: 'Email Templates',
    type: 'danger',
    icon: 'fa fa-envelope',
    path: '/operator/management',
    roles: ['admin', 'director'],
    id: 'email-templates-table',
    parentName: 'Management',
    searchKey: 'email template, templates, email',
  },
  {
    name: 'Service Surveys',
    type: 'danger',
    icon: 'fa fa-envelope',
    path: '/operator/service-surveys',
    id: 'service-surveys',
    parentName: 'Service Surveys',
  },
  {
    name: 'Display Email Example',
    type: 'danger',
    icon: 'fa fa-envelope',
    path: '/operator/display-email-example',
    id: 'display-email-example',
    parentName: 'Display Email Example',
  },
  {
    name: 'Display SMS Example',
    type: 'danger',
    icon: 'fa fa-inbox',
    path: '/operator/display-sms-example',
    id: 'display-sms-example',
    parentName: 'Display SMS Example',
  },
  {
    name: 'Partner Individual Charge',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'partnership-operator'],
    id: 'partner-individual-charge',
    parentName: 'Partners',
  },
  {
    name: 'Partner Caller Credits Charge',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'partnership-operator'],
    id: 'partner-caller-credits-charge',
    parentName: 'Partners',
  },
  {
    name: 'Charge Invoice',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'partnership-operator'],
    id: 'charge-invoice',
    parentName: 'Partners',
  },
  {
    name: 'Apply Manual Subsidy',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/management',
    roles: ['admin', 'partnership-operator'],
    id: 'apply-manual-subsidy',
    parentName: 'Partners',
  },
  {
    name: 'User Interactions for Profile',
    type: 'danger',
    icon: 'fa fa-area-chart',
    path: '/operator/user-interactions',
    id: 'profile-interactions',
    parentName: 'User Interactions',
  },
  {
    name: 'User Interactions for Scheduled Ride',
    type: 'danger',
    icon: 'fa fa-area-chart',
    path: '/operator/user-interactions',
    id: 'scheduled-ride-interactions',
    parentName: 'User Interactions',
  },
  {
    name: 'Caller Date Events',
    type: 'danger',
    icon: 'fa fa-area-chart',
    path: '/operator/user-interactions',
    id: 'caller-date-events',
    parentName: 'User Interactions',
  },
  {
    name: 'Submit a Kudos Call to a Team Lead',
    type: 'success',
    icon: 'fa fa-pencil-square-o',
    path: '/operator/submit-kudos-call',
    parentName: 'Submit a Kudos Call',
  },
  {
    name: 'AI Prompts',
    type: 'success',
    icon: 'fa fa-pencil-square-o',
    path: '/operator/ai-tools',
    roles: ['admin', 'director', 'supervisor'],
    id: 'ai-prompts',
    parentName: 'AI Tools',
    searchKey: 'ai prompt, prompts, ai tools',
  },
  {
    name: 'AI Agent Instructions',
    type: 'success',
    icon: 'fa fa-pencil-square-o',
    path: '/operator/agent/agent',
    roles: ['admin', 'director', 'teamLead', 'qualityAssurance', 'rideTeamLead'],
    parentName: 'AI Agents',
    searchKey: 'ai agent',
  },
  {
    name: 'AI Agent Settings',
    type: 'success',
    icon: 'fa fa-pencil-square-o',
    path: '/operator/agent/agent',
    roles: ['admin', 'director', 'teamLead', 'qualityAssurance', 'rideTeamLead'],
    parentName: 'AI Agents',
    searchKey: 'ai agent',
  },
  {
    name: 'AI Agent Examples',
    type: 'success',
    icon: 'fa fa-pencil-square-o',
    path: '/operator/agent/agent',
    roles: ['admin', 'director', 'teamLead', 'qualityAssurance', 'rideTeamLead'],
    parentName: 'AI Agents',
    searchKey: 'ai agent',
  },
  {
    name: 'Partnership Account Request',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'partnership-account',
    parentName: 'Partners',
  },
  {
    name: 'Partner Callers',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator'],
    id: 'all-partner-callers',
    parentName: 'Partners',
  },
  {
    name: 'Partner Geo Validation',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator', 'supervisor', 'teamLead', 'partnership-caller-operator', 'rideTeamLead'],
    id: 'partner-geo-validation',
    parentName: 'Partners',
  },
  {
    name: 'Update Partner Caller Rides',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator'],
    id: 'update-partner-caller-rides',
    parentName: 'Partners',
  },
  {
    name: 'Update Partner Caller Ride Allowance Tier',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator'],
    id: 'update-partner-caller-ride-allowance-tier',
    parentName: 'Partners',
  },
  {
    name: 'Add Partner Caller Credits',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator', 'partner'],
    id: 'add-partner-caller-credits',
    parentName: 'Partners',
  },
  {
    name: 'Remove Partner Caller Credits',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator', 'partner'],
    id: 'remove-partner-caller-credits',
    parentName: 'Partners',
  },
  {
    name: 'Assign Partner to Ride',
    type: 'warning',
    icon: 'fa fa-taxi',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator'],
    id: 'assign-partner-to-ride',
    parentName: 'Partners',
  },
  {
    name: 'Partner Subsidy Pot',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    roles: ['admin', 'partnership-operator'],
    id: 'partner-subsidy-pot',
    parentName: 'Partners',
  },
  {
    name: 'Partners List',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'partners-table',
    parentName: 'Partners',
  },
  {
    name: 'Partner Registration Page',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partner-registration',
    roles: ['admin', 'partnership-operator'],
    id: 'partner-registration',
    parentName: 'Partners',
  },
  {
    name: 'Partner Members',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'partner-members',
    parentName: 'Partners',
  },
  {
    name: 'Partner Subsidy Location List',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'partner-subsidy-location-list',
    parentName: 'Partners',
  },
  {
    name: 'New Subsidy Migration',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'partner-new-subsidy-migration',
    parentName: 'Partners',
    roles: ['admin'],
  },
  {
    name: 'Number of Rides Taken Per Partner',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'number-of-rides-taken-per-partner',
    parentName: 'Partners',
    roles: ['admin', 'partnership-operator'],
  },
  {
    name: 'Partners Tipping',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'partner-tipping',
    parentName: 'Partners',
    roles: ['admin', 'partnership-operator'],
  },
  {
    name: 'Update Local Taxi Partner Ride',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'update-local-taxi-partner-ride',
    parentName: 'Partners',
    roles: ['admin', 'partnership-operator'],
  },
  {
    name: 'Reactivate Partner Member',
    type: 'warning',
    icon: 'fa fa-users',
    path: '/operator/partners',
    id: 'reactivate-partner-member',
    parentName: 'Partners',
    roles: ['admin', 'partner', 'partnership-operator', 'partnership-caller-operator'],
  },
  {
    name: 'Affiliate Table',
    type: 'warning',
    icon: 'fa fa-handshake-o',
    path: '/operator/affiliate',
    roles: ['admin', 'affiliate-manager'],
    id: 'affiliate-table',
    parentName: 'Affiliate',
  },
  {
    name: 'Create Affiliate',
    type: 'warning',
    icon: 'fa fa-handshake-o',
    path: '/operator/affiliate-create',
    roles: ['admin', 'affiliate-manager'],
    id: 'create-update-affiliate',
    parentName: 'Affiliate',
  },
  {
    name: 'FAQ',
    icon: 'fa fa-question',
    type: 'info',
    path: '/operator/faq',
    parentName: 'FAQ',
  },
  {
    name: 'Fraud Check',
    icon: 'fa fa-assistive-listening-systems',
    type: 'info',
    path: '/operator/fraud-check',
    parentName: 'Fraud Check',
  },
  {
    name: 'Registration',
    icon: 'fa fa-registered',
    type: 'success',
    path: '/operator/registration',
    parentName: 'Registration',
  },
  {
    name: 'Delivery Search',
    icon: 'fa fa-cutlery',
    type: 'warning',
    path: '/operator/delivery-search',
    parentName: 'Gourmet',
  },
  {
    name: 'Delivery Need Love',
    icon: 'fa fa-cutlery',
    type: 'warning',
    path: '/operator/delivery-need-love',
    id: 'create-gourmet-need-love',
    roles: ['admin', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Delivery SMS',
    icon: 'fa fa-cutlery',
    type: 'warning',
    path: '/operator/delivery-sms',
    roles: ['gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Delivery Receipt',
    icon: 'fa fa-line-chart',
    type: 'warning',
    path: '/operator/delivery-receipt',
    roles: ['gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator', 'rideTeamLead'],
    parentName: 'Gourmet',
  },
  {
    name: 'Service Accounts',
    icon: 'fa fa-user',
    type: 'warning',
    path: '/operator/service-accounts',
    roles: ['admin', 'director', 'gourmet-supervisor', 'lossPreventionGourmet'],
    parentName: 'Gourmet',
  },
  {
    name: 'Create Service Account',
    type: 'danger',
    icon: 'fa fa-user',
    path: '/operator/create-service-account',
    id: 'create-update-service-account',
    roles: ['admin', 'director', 'gourmet-supervisor', 'lossPreventionGourmet'],
    parentName: 'Gourmet',
  },
  {
    name: 'Scheduled Delivery',
    icon: 'fa fa-line-chart',
    type: 'warning',
    path: '/operator/scheduled-delivery',
    roles: ['gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Delivery Manual Order',
    icon: 'fa fa-cutlery',
    type: 'warning',
    path: '/operator/delivery-manual-order',
    roles: ['admin', 'director', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Delivery Transactions',
    icon: 'fa fa-line-chart',
    type: 'warning',
    path: '/operator/delivery-transactions',
    roles: ['gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Gourmet Registration',
    icon: 'fa fa-line-chart',
    type: 'warning',
    path: '/operator/gourmet-registration',
    roles: ['admin', 'director', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Gourmet Resume Registration',
    icon: 'fa fa-line-chart',
    type: 'warning',
    path: '/operator/gourmet-resume-registration',
    roles: ['admin', 'director', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
    parentName: 'Gourmet',
  },
  {
    name: 'Pending Grocery NeedLoves',
    icon: 'fa fa-shopping-cart',
    path: '/operator/live-grocery',
    id: 'pending-grocery-need-loves',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'LiveGrocery',
  },
  {
    name: 'Unpaid Grocery Orders',
    icon: 'fa fa-shopping-cart',
    path: '/operator/live-grocery',
    id: 'unpaid-grocery-orders',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'LiveGrocery',
  },
  {
    name: 'Pull Up Grocery Receipt',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'pull-up-grocery-receipt',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Update Grocery Status',
    icon: 'fa fa-shopping-cart',
    type: 'info',
    path: '/operator/grocery',
    id: 'grocery-status',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Send Grocery Receipt',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'send-grocery-receipt',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Create Grocery',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'create-grocery',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'EBT Card Information',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'ebt-card-information',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Get Grocery Cost',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'get-grocery-estimation-and-cost',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
      'facebookLeads-registrations-operator',
      'facebookLeads-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Create Grocery Shopper Note',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'create-grocery-shopper-note',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Remove Grocery Shopper Note',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'remove-grocery-shopper-note',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Rescan Grocery for Changes',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'scan-grocery',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Grocery Manual Charge',
    icon: 'fa fa-shopping-cart',
    type: 'info',
    path: '/operator/grocery',
    id: 'grocery-charge',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Cancel Grocery',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'cancel-grocery',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Send Grocery History',
    type: 'warning',
    icon: 'fa fa-copy',
    path: '/operator/grocery',
    id: 'send-grocery-history',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Create Pending Grocery Cart',
    type: 'warning',
    icon: 'fa fa-clock-o',
    path: '/operator/grocery',
    id: 'create-pending-grocery-cart',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Create Saved Grocery From Instacart Cart',
    type: 'warning',
    icon: 'fa fa-clock-o',
    path: '/operator/grocery',
    id: 'create-saved-grocery-from-instacart-cart',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Pending Grocery Cart List',
    type: 'warning',
    icon: 'fa fa-clock-o',
    path: '/operator/grocery',
    id: 'pending-grocery-cart-list',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Search Available Grocery Stores',
    type: 'warning',
    icon: 'fa fa-search',
    path: '/operator/grocery',
    id: 'grocery-available-stores',
    parentName: 'Grocery',
  },
  {
    name: 'Instacart Accounts',
    type: 'danger',
    icon: 'fa fa-user',
    path: '/operator/grocery',
    id: 'instacart-accounts-table',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Create Instacart Account',
    type: 'danger',
    icon: 'fa fa-user',
    path: '/operator/create-instacart-account',
    id: 'create-update-instacart-account',
    roles: ['admin', 'supervisor'],
    parentName: 'Grocery',
  },
  {
    name: 'Update Instacart Account',
    type: 'danger',
    icon: 'fa fa-user',
    path: '/operator/update-instacart-account',
    id: 'create-update-instacart-account',
    roles: ['admin', 'supervisor'],
    parentName: 'Grocery',
  },
  {
    name: 'Blocked Instacart Account',
    icon: 'fa fa-shopping-cart',
    type: 'info',
    path: '/operator/grocery',
    id: 'blocked-instacart-account',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Saved Grocery',
    icon: 'fa fa-heart',
    path: '/operator/saved-grocery',
    id: 'saved-groceries',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Saved Grocery',
  },
  {
    name: 'Saved Grocery Details',
    icon: 'fa fa-heart',
    path: '/operator/saved-grocery',
    id: 'saved-grocery-details',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Saved Grocery',
  },
  {
    name: 'Create Saved Grocery',
    icon: 'fa fa-heart',
    path: '/operator/create-saved-grocery',
    id: 'create-saved-grocery',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Create Saved Grocery',
  },
  {
    name: 'Scheduled Grocery',
    icon: 'fa fa-calendar',
    path: '/operator/scheduled-grocery',
    id: 'scheduled-groceries',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Scheduled Grocery',
  },
  {
    name: 'Scheduled Grocery Details',
    icon: 'fa fa-calendar',
    path: '/operator/scheduled-grocery',
    id: 'scheduled-grocery-details',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Scheduled Grocery',
  },
  {
    name: 'Create Scheduled Grocery',
    icon: 'fa fa-calendar',
    path: '/operator/scheduled-grocery-form',
    id: 'scheduled-grocery-form',
    type: 'warning',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Create Scheduled Grocery',
  },
  {
    name: 'Grocery Address Search',
    type: 'warning',
    icon: 'fa fa-shopping-cart',
    path: '/operator/grocery',
    id: 'grocery-address-search',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Gourmet Order History',
    type: 'warning',
    icon: 'fa fa-cutlery',
    path: '/operator/delivery-order-history',
    id: 'gourmet-history',
    roles: deliveryTabRoles,
    parentName: 'Delivery Order History',
  },
  {
    name: 'Grocery History',
    type: 'warning',
    icon: 'fa fa-search',
    path: '/operator/delivery-order-history',
    id: 'grocery-search',
    roles: deliveryTabRoles,
    parentName: 'Delivery Order History',
  },
  {
    name: 'Grocery Details',
    type: 'warning',
    icon: 'fa fa-search',
    path: '/operator/delivery-order-history',
    id: 'grocery-details',
    roles: deliveryTabRoles,
    parentName: 'Delivery Order History',
  },
  {
    name: 'Grocery Events',
    type: 'warning',
    icon: 'fa fa-search',
    path: '/operator/delivery-order-history',
    id: 'grocery-events',
    roles: deliveryTabRoles,
    parentName: 'Delivery Order History',
  },
  {
    name: 'All Grocery Transactions',
    type: 'danger',
    icon: 'fa fa-money',
    path: '/operator/delivery-order-history',
    id: 'grocery-transaction-list',
    roles: deliveryTabRoles,
    parentName: 'Delivery Order History',
  },
  {
    name: 'Search Grocery Need Love',
    type: 'danger',
    icon: 'fa fa-search',
    path: '/operator/delivery-order-history',
    id: 'search-grocery-need-love',
    roles: deliveryTabRoles,
    parentName: 'Delivery Order History',
  },
  {
    name: 'User Plan History',
    type: 'warning',
    icon: 'fa fa-area-chart',
    id: 'user-plan-history',
    path: '/operator/user-plan',
    parentName: 'User Plan',
  },
  {
    name: 'Send Subscription Receipt',
    type: 'warning',
    icon: 'fa fa-area-chart',
    id: 'send-subscription-receipt',
    path: '/operator/user-plan',
    parentName: 'User Plan',
  },
  {
    name: 'Send Subscription History',
    type: 'warning',
    icon: 'fa fa-area-chart',
    id: 'send-subscription-history',
    path: '/operator/user-plan',
    parentName: 'User Plan',
  },
  {
    name: 'Request Home Services',
    icon: 'fa fa-address-book',
    type: 'info',
    path: '/operator/home-services',
    parentName: 'Home Services',
  },
  {
    name: 'Home Service Orders',
    icon: 'fa fa-address-book',
    type: 'info',
    path: '/operator/home-services/orders',
    parentName: 'Home Services',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'homeServices-operator'],
  },
  {
    name: 'Home Service Providers',
    icon: 'fa fa-address-book',
    type: 'info',
    path: '/operator/home-services/providers',
    parentName: 'Home Services',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'homeServices-operator'],
  },
  {
    name: 'Home Service Supervisor Support',
    type: 'danger',
    icon: 'fa fa-heart',
    path: '/operator/need-love',
    id: 'home-service-supervisor-support',
    parentName: 'Need Love',
  },
  {
    name: 'A/B Tests',
    icon: 'fa fa-tachometer',
    type: 'warning',
    id: 'ab-tests',
    path: '/operator/ab-tests',
    parentName: 'Management',
  },
  {
    name: 'A/B Test Group Users',
    icon: 'fa fa-tachometer',
    type: 'warning',
    id: 'ab-test-group-users',
    path: '/operator/ab-tests',
    parentName: 'Management',
    roles: ['admin', 'director'],
  },
  {
    name: 'Refund GoGo Credits',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'refund-gogo-credits',
    parentName: 'Refund',
  },
  {
    name: 'Refund Deposit',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'refund-deposit',
    parentName: 'Refund',
  },
  {
    name: 'Remove GoGo Credits',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    id: 'remove-gogo-credits',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    parentName: 'Refund',
  },
  {
    name: 'Add Free GoGo Credits',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    id: 'add-free-gogo-credits',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    parentName: 'Refund',
  },
  {
    name: 'Grant Supervisor Retention Offer',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    id: 'grant-supervisor-retention-offer',
    roles: ['admin', 'director', 'supervisor', 'gourmet-supervisor'],
    parentName: 'Refund',
  },
  {
    name: 'Refund Ride Costs',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'refund-ride-costs',
    parentName: 'Refund',
  },
  {
    name: 'Refund Custom Charge',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/refunds',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
    id: 'refund-custom-charge',
    parentName: 'Refund',
  },
  {
    name: 'Mark as End Call Log',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/calls',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'mark-as-end-call-log',
    parentName: 'Calls',
  },
  {
    name: 'Gourmet Estimator',
    type: 'success',
    icon: 'fa fa-dollar',
    path: '/operator/gourmet-estimator',
    id: 'get-estimation',
    parentName: 'Price Estimator',
  },
  {
    name: 'Manual Update Plan With Refund',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/membership',
    id: 'manual-update-plan',
    parentName: 'Membership',
  },
  {
    name: 'Update Plan Without Charge',
    type: 'danger',
    icon: 'fa fa-user-md',
    path: '/operator/membership',
    roles: ['admin', 'director', 'supervisor'],
    id: 'update-plan-without-charge',
    parentName: 'Membership',
  },
  {
    name: 'Refund Old Subscription',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/membership',
    roles: ['admin', 'director', 'supervisor'],
    id: 'refund-subscription',
    parentName: 'Membership',
  },
  {
    name: 'Deactivate Account',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/membership',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
    id: 'deactivate-account',
    parentName: 'Membership',
  },
  {
    name: 'Deactivate Soft Registered Account',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/membership',
    id: 'deactivate-soft-registered-account',
    parentName: 'Membership',
  },
  {
    name: 'Generate Unsubscribe Link',
    type: 'danger',
    icon: 'fa fa-link',
    path: '/operator/membership',
    id: 'generate-retention-link',
    parentName: 'Membership',
  },
  {
    name: 'Reactivate Account',
    type: 'danger',
    icon: 'fa fa-recycle',
    path: '/operator/membership',
    id: 'reactivate-account',
    parentName: 'Membership',
  },
  {
    name: 'User Plan History',
    type: 'warning',
    icon: 'fa fa-area-chart',
    id: 'user-plan-history',
    path: '/operator/membership',
    parentName: 'Membership',
  },
  {
    name: 'Caller Plan Addons',
    type: 'warning',
    icon: 'fa fa-area-chart',
    id: 'caller-plan-addons',
    path: '/operator/membership',
    parentName: 'Membership',
  },
  {
    name: 'Apply Plan Addon',
    type: 'warning',
    icon: 'fa fa-area-chart',
    id: 'apply-plan-addon',
    path: '/operator/membership',
    parentName: 'Membership',
  },
  {
    name: 'URL Shortener',
    type: 'success',
    icon: 'fa fa-dollar',
    path: '/operator/management',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'lossPrevention', 'rideTeamLead'],
    id: 'url-shortener',
    parentName: 'Management',
  },
  {
    name: 'My Forms',
    type: 'success',
    icon: 'fa fa-file-text-o',
    path: '/operator/user-forms',
    id: 'current-user-forms',
    parentName: 'User Forms',
  },
  {
    name: 'Buy Twilio Numbers',
    type: 'success',
    icon: 'fa fa-volume-control-phone',
    path: '/operator/management',
    roles: ['admin', 'director'],
    id: 'buy-twilio-numbers',
    parentName: 'Management',
  },
  {
    name: 'Operator Registration Performances',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/registration-performances',
    id: 'aggregate-view',
    parentName: 'Operator Registration Performances',
  },
  {
    name: 'Operator Weekly Breakdown',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/registration-performances',
    id: 'operator-weekly-breakdown',
    parentName: 'Operator Registration Performances',
  },
  {
    name: 'Operator Performance Calls',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/registration-performances',
    id: 'operator-performance-calls',
    parentName: 'Operator Registration Performances',
  },
  {
    name: 'Exclude Calls From Operator Performances',
    type: 'warning',
    icon: 'fa fa-line-chart',
    path: '/operator/registration-performances',
    id: 'exclude-calls-from-operator-performances',
    parentName: 'Operator Registration Performances',
    roles: ['admin', 'director'],
  },
  {
    name: 'Operator Ride Performances Summary',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/ride-performances',
    id: 'operator-ride-performances',
    parentName: 'Operator Ride Performances',
  },
  {
    name: 'Operator Ride Performances Weekly Breakdown',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/ride-performances',
    id: 'operator-ride-performances-weekly-breakdown',
    parentName: 'Operator Ride Performances',
  },
  {
    name: 'Grocery Manual Charge',
    icon: 'fa fa-shopping-cart',
    type: 'info',
    path: '/operator/grocery',
    id: 'grocery-charge',
    roles: [
      'admin',
      'director',
      'supervisor',
      'grocery-operator',
      'grocery-manager',
      'lossPreventionGrocery',
      'virtualAssistanceGrocery',
      'gourmet-operator',
    ],
    parentName: 'Grocery',
  },
  {
    name: 'Grocery Lists',
    type: 'warning',
    icon: 'fa fa-list',
    path: '/operator/grocery-lists',
    id: 'grocery-lists',
    parentName: 'Grocery',
  },
  {
    name: 'Coaching Assistant',
    type: 'info',
    icon: 'fa fa-star',
    path: '/operator/team-leads',
    id: 'coaching-assistant',
    parentName: 'Team Leads',
    roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
  },
  {
    name: 'Welcome Texts',
    type: 'info',
    icon: 'fa fa-envelope',
    path: '/operator/welcome-texts',
    id: 'welcome-texts',
    parentName: 'Welcome Texts',
  },
  {
    name: 'Weekly Registration Rate Targets',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/registration-performances',
    id: 'weekly-registration-rate-targets',
    parentName: 'Operator Registration Performances',
    roles: ['admin', 'director'],
  },
  {
    name: 'Live Alerts',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/live-alerts',
    id: 'live-alerts',
    parentName: 'Live Alerts',
    roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
  },
  {
    name: 'Live Support Tasks',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/live-alerts',
    id: 'live-alerts',
    parentName: 'Live Alerts',
    roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
  },
  {
    name: 'Support Team',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/live-alerts',
    id: 'SupportTeam',
    parentName: 'Live Alerts',
    roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
  },
  {
    name: 'Online Operators',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/live-alerts',
    id: 'ride-safety-support-online-operators',
    parentName: 'Live Alerts',
    roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
  },
  {
    name: 'Offline Operators',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/live-alerts',
    id: 'ride-safety-support-offline-operators',
    parentName: 'Live Alerts',
    roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
  },
  {
    name: 'Request Alert',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/operator-tasks',
    id: 'request-alert',
    parentName: 'Operator Tasks',
    roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
  },
  {
    name: 'Live Tasks',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/operator-tasks',
    id: 'live-tasks',
    parentName: 'Live Tasks',
    roles: ['admin', 'director', 'teamLead', 'supervisor', 'onboarding-team-lead', 'rideTeamLead', 'lossPrevention'],
  },
  {
    name: 'Completed Tasks',
    type: 'info',
    icon: 'fa fa-headphones',
    path: '/operator/operator-tasks',
    id: 'completed-tasks',
    parentName: 'Operator Tasks',
    roles: ['admin', 'director', 'teamLead', 'supervisor', 'onboarding-team-lead', 'rideTeamLead', 'lossPrevention'],
  },
  {
    name: 'Incoming Grocery Orders',
    icon: 'fa fa-truck',
    path: '/operator/live-deliveries',
    id: 'incoming-groceries',
    type: 'warning',
    roles: deliveryTabRoles,
    parentName: 'Delivery Live Orders',
  },
  {
    name: 'Incoming Gourmet Orders',
    icon: 'fa fa-truck',
    path: '/operator/live-deliveries',
    id: 'incoming-gourmet',
    type: 'warning',
    roles: deliveryTabRoles,
    parentName: 'Delivery Live Orders',
  },
  {
    name: 'Individual Statistics',
    type: 'info',
    icon: 'fa fa-line-chart',
    path: '/operator/individual-statistics',
    id: 'operator-individual-statistic',
    parentName: 'Operator Statistics',
  },
];
